import { Expose, Type, Transform } from 'class-transformer';
import * as uuid from 'uuid';

import { Default, ExposeRawData } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';

import { IFsLprResult } from '../interfaces/common/result';

export class SnLprFlockRead extends SnModel implements IFsLprResult {
  @Expose()
  @Type(() => Date)
  public eventTimestamp: Date;

  @Expose()
  public vehicleMake: string;

  @Expose()
  @Transform((value) => {
    // This should be handled on the backend; Remove this @Transform if/when that's done.
    if (value?.toLowerCase() === 'unknown') {
      return '';
    }
    return value;
  })
  public color: string;

  @Expose()
  public id: string;

  @Expose()
  public backRack: boolean;

  @Expose()
  public topRack: boolean;

  @Expose()
  public bumperStickers: boolean;

  @Expose()
  public windowStickers: boolean;

  @ExposeRawData()
  public box: any;

  @ExposeRawData()
  public geometry: any;

  @Expose()
  public cameraId: string;

  @Expose()
  public plate: string;

  @Expose()
  public vehicleType: string;

  @Expose()
  public imageUrl: string;

  @Expose()
  public type: string;

  @Expose()
  @Transform((value) => {
    // This should be handled on the backend; Remove this @Transform if/when that's done.
    if (value?.toLowerCase() === 'unknown') {
      return '';
    }

    return value;
  })
  public plateState: string;

  @Expose()
  public cameraName: string;

  @Expose()
  @Default({})
  public details: any;

  @Expose()
  @Default('flock')
  public integratedLprType: string = 'flock';

  get plateImageUrl(): string {
    // Always returning null because flock response does not have a plate image URL
    return null;
  }

  get contextImageUrl(): string {
    return this.imageUrl;
  }

  get vehicleBody(): string {
    return this.vehicleType;
  }

  get hitType(): string {
    return this.isHit ? 'hit' : 'read';
  }

  get isHit(): boolean {
    return true;
  }

  get hitReason(): string {
    // Flock API doesn't return the hit reason in their response but some of the other providers do.
    // Since we're creating a common interface to map heterogenous responses to a common one to render on the FE,
    // we're returning an empty string here.
    return '';
  }

  get state(): string {
    return this.plateState;
  }

  get displayState(): string {
    return this.plateState;
  }

  get createdTimestamp(): Date {
    return new Date(this.eventTimestamp);
  }

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
    if (!this.id) {
      this.id = uuid.v4();
    }
  }

  get googleLatLng(): google.maps.LatLng {
    return new google.maps.LatLng(this.geometry.coordinates[1], this.geometry.coordinates[0]);
  }
}
